import { searchAdministrators, deleteAdministrator } from "../api";
import Title from "../components/TheTitle.vue";
import Form from "../components/UserListForm.vue";
import Table from "../components/UserListTable.vue";
import { UserAuth } from "../const/userAuthority";
import { Authorize } from "../utils/authorize";
export default {
    name: "UserList",
    data() {
        return {
            searchedAdministrators: [],
            crmUserIdCondition: [],
            storeIdCondition: [],
            isAdminList: false,
            isSysAdmin: this.$store.state.authority === UserAuth.SYSTEM_ADMIN.code,
            errMsgs: [],
        };
    },
    components: {
        Title,
        Form,
        Table,
    },
    created: async function () {
        // 権限チェック
        const authority = this.$store.state.authority;
        if (authority !== UserAuth.SYSTEM_ADMIN.code &&
            authority !== UserAuth.STORE_ADMIN.code) {
            // エラーページに遷移
            this.$router.push({
                name: "not-found",
                params: { catchAll: "not-found" },
            });
            // 処理強制終了
            return false;
        }
        if (Date.now() / 1000 > this.$store.state.tokenExp) {
            if (!(await Authorize.isAuth())) {
                // 認証失敗：ログイン画面へ遷移
                this.$router.push({
                    name: "login",
                    query: { redirect: this.$route.path },
                });
                return false;
            }
        }
    },
    methods: {
        async searchAdministrator(crmUserId, storeId) {
            if (Date.now() / 1000 > this.$store.state.tokenExp) {
                if (!(await Authorize.isAuth())) {
                    // 認証失敗：ログイン画面へ遷移
                    this.$router.push({
                        name: "login",
                        query: { redirect: this.$route.path },
                    });
                    return false;
                }
            }
            const rspBody = await searchAdministrators(crmUserId, storeId);
            if (rspBody.result.messages.length) {
                this.searchedAdministrators = [];
                // 失敗した場合、エラーメッセージをポップアップにセットして表示
                this.$store.commit("setMessages", rspBody.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                // 成功した場合、取得したレコードを渡す
                this.searchedAdministrators = rspBody.detail;
                // 検索条件を保持させる
                this.crmUserIdCondition = crmUserId;
                this.storeIdCondition = storeId;
            }
        },
        async deleteAdministrator(crmUserId) {
            if (Date.now() / 1000 > this.$store.state.tokenExp) {
                if (!(await Authorize.isAuth())) {
                    // 認証失敗：ログイン画面へ遷移
                    this.$router.push({
                        name: "login",
                        query: { redirect: this.$route.path },
                    });
                    return false;
                }
            }
            const rspBody = await deleteAdministrator(crmUserId);
            // 削除押下後、再度フォームの検索条件を取得
            if (rspBody.result.messages.length) {
                this.searchedAdministrators = [];
                // 失敗した場合、エラーメッセージをポップアップにセットして表示
                this.searchedAdministrators = rspBody.detail;
                this.$store.commit("setMessages", rspBody.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                // 削除押下後、再度フォームの検索条件でレコードを取得
                const administratorsRspBody = await searchAdministrators(this.crmUserIdCondition, this.storeIdCondition);
                this.searchedAdministrators = administratorsRspBody.detail;
            }
        },
        changeUserListType() {
            this.isAdminList = true;
        },
    },
    async mounted() {
        await Authorize.isExpired(this);
    },
};
